/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {partnerOrderInformation} from '../api'

export const useMutationPartnerOrderInformation = createReactQueryMutationHook('partnerOrderInformation', partnerOrderInformation)
